module.exports = __webpack_public_path__ + "static/media/soc.e3a45919.svg";